import React from 'react';
import { Card, CardContent, Typography, Box } from '@mui/material';

const colorMap = {
  primary: '#003781',
  warning: '#ff9800',
  info: '#2196f3',
  success: '#4caf50'
};

const MetricsCard = ({ title, value, color = 'primary' }) => (
  <Card 
    elevation={3}
    sx={{ 
      backgroundColor: colorMap[color],
      color: '#fff', 
      minHeight: 140,
      borderRadius: 3,
      cursor: 'pointer',
      transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
      '&:hover': {
        transform: 'translateY(-4px)',
        boxShadow: '0 8px 25px rgba(0,0,0,0.15)'
      }
    }}
  >
    <CardContent sx={{ p: 3 }}>
      <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center" textAlign="center">
        <Typography variant="subtitle1" sx={{ opacity: 0.9, fontWeight: 600, mb: 2 }}>
          {title}
        </Typography>
        <Typography variant="h3" sx={{ fontWeight: 800 }}>
          {value.toLocaleString()}
        </Typography>
      </Box>
    </CardContent>
  </Card>
);

export default MetricsCard;